@if (text) {
	<p class="au-body-text" [class.small-font]="smallFont">
		{{ text }}
	</p>
}

@if (!text) {
	<span class="no-data" [class.small-font]="smallFont">
		{{ fallbackText }}
	</span>
}
